export enum PlayerEvent {
	CONNECTION = "connection",
	SELECT_SONG = "selectSong",
	PLAY = "play",
	ON_PLAY = "onPlay",
	PAUSE = "pause",
	ON_PAUSE = "onPause",
	DURATION = "duration",
	CURRENT_TIME = "currentTime",
	SET_TIME = "setTime",
	SONG_END = "songEnd",
	INIT_CASTING_SESSION = "initCastingSession",
	STRIPE_ID = "stripeId",
	CURRENT_SONG_DETAILS = "currentSongDetails",
	NEXT_SONG_DETAILS = "nextSongDetails",
	MUTE_VOCAL_GUIDE = "muteVocalGuide",
	ON_MUTE_VOCAL_GUIDE = "onMuteVocalGuide",
	UNMUTE_VOCAL_GUIDE = "unmuteVocalGuide",
	ON_UNMUTE_VOCAL_GUIDE = "onUnmuteVocalGuide",
	START_SESSION = "startSession",
	SET_SESSION_END_OVERLAY = "setSessionEndOverlay",
	END_SESSION = "endSession",
	ON_VOCAL_GUIDE_LOADED = "onVocalGuideLoaded",
	SHOW_LAST_SONG_TV_MESSAGE = "showLastSongTVMessage",
	SHOW_LAST_30_MINUTES_TV_MESSAGE = "showLast30MinutesTVMessage",
	SHOW_LAST_20_MINUTES_TV_MESSAGE = "showLast20MinutesTVMessage",
	SHOW_LAST_10_MINUTES_TV_MESSAGE = "showLast10MinutesTVMessage",
	SHOW_VIDEO_TV_MESSAGE = "showVideoTVMessage",
	CLEAR_TV_MESSAGE = "clearTVMessage",
	PLAY_LAST_SONG = "play_last_song",
	PlayerEvent = "PlayerEvent",
	UPDATE_VOLUME_LEVEL = "updateVolumeLevel",
	SYNCHRONIZE_USER_ID_ACCROSS_SCREEN = "synchronizeUserIdAccrossScreens",
	NOTIFY_THAT_LOGO_IS_LOADED = "Notify_That_Logo_Is_Loaded",
	LAUNCH_AUTO_SCREEN_SPLIT_MODE = "LaunchAutoScreenSplitMode",
	WAITING_LIST_UPDATE = "waitingListUpdate",
	IS_STORAGE_ACTIVATED = "is_storage_activated",
	IS_WAITING_SONG_ACTIVATED = "is_waiting_song_activated",
	SWITCH_LANGUAGE = "switching_language",
	TAKE_PHOTO = "take_photo",
	TAKE_VIDEO = "take_video",
	STOP_VIDEO = "stop_video",
	CAMERA_ON = "camera_on",
	CAMERA_OFF = "camera_off",
	START_GAME = "start_game",
	CLOSE_GAME = "close_game",
	IS_ROULETTE_ACTIVATED = "is_roulette_activated",
	PLAY_ROULETTE = "play_roulette",
	ROULLETTE_ANIMATION_END = "roulette_animation_end",
	PLAY_CUSTOMER_VIDEO = "play_customer_video",
}

export enum PlayerEventGroup {
	TOGGLE_PLAY = "togglePlay",
	ON_TOGGLE_PLAY = "onTogglePlay",
	TOGGLE_MUTE_VOCAL_GUIDE = "toggleMuteVocalGuide",
	ON_TOGGLE_MUTE_VOCAL_GUIDE = "onToggleMuteVocalGuide",
}

export type PlayerEventsListeners = {
	[eventType in PlayerEvent]?: (event: MessageEvent) => void;
};

export interface PlayerSongDetails {
	title: string;
	artistName: string;
	singerName?: string;
}

export type SendPlayerEvent = (
	eventType: PlayerEvent,
	data?: string | null,
	timestamp?: number,
) => void;
